import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  currentDate = new Date();

  constructor(
    private formBuilder: FormBuilder,
    private titleService: Title,
    private meta: Meta,
    private appService: AppService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) { }
  demoForm: FormGroup;
  submitted : boolean;

  ngOnInit() {
    this.titleService.setTitle('Kaims IT Services | Custom Software Development | ERP Development | Website Development Company in Ahmedabad - India');
    this.meta.updateTag({ name: "description", content: 'Partner with Kaims IT Services for your ERP, CRM, Application Management and Cloud Solutions needs by hiring our CRM and .NET Experts in India' });
    this.meta.updateTag({ name: "keywords", content: 'Web Development Company India, Mobile App Development Company India and India, ERP and CRM Service Provider, Kaims IT Services' });
    this.meta.updateTag({ name: "author", content: 'Kaims IT Services' });
    this.demoForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      phone: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(10)])],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      // subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.demoForm.controls; }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.demoForm.invalid) {
      return;
    } else {
      this.spinner.show();
      var payload = {
        udiseCode: 1,
        fullName: this.demoForm.value.name,
        mobileNumber: this.demoForm.value.phone,
        email: this.demoForm.value.email,
        remark: this.demoForm.value.message,
        createdBy: 1,
        createdDate: this.currentDate.toISOString()
      }

      this.appService.post(`Contact/Insert`, payload, environment.authKey).subscribe((res: any) => {
        if (res?.status) {
          this.toastr.success(res?.message);
          this.resetForm();
          this.spinner.hide();
          this.submitted = false;
        } else {
          this.spinner.hide();
          this.toastr.error(res?.message);
        }
      }, (error: any) => {
        console.log(error);
        this.spinner.hide();
        this.toastr.error('Something went wrong');
      });
    }
  }

  resetForm() {
    this.demoForm.controls['name'].setValue('');
    this.demoForm.controls['phone'].setValue('');
    this.demoForm.controls['email'].setValue('');
    // this.demoForm.controls['subject'].setValue('');
    this.demoForm.controls['message'].setValue('');
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
      return false;
    }
    return true;
  }

}
